import { styled } from '@vebox/etui-system';
import { useState, useEffect, createElement, Children, cloneElement } from 'react';
import { b as _extends, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const RadioDiv = styled(Div)`
  position: relative;
  display: flex;
  flex-direction: ${({
  row
}) => row ? 'row' : 'column'};
  justify-content: space-between;
`;

const RadioGroup = props => {
  const {
    selected,
    onChange,
    horizontal,
    children,
    styles
  } = props;
  const [value, setValue] = useState(selected);
  const handleChange = e => {
    const {
      value: eventValue,
      checked
    } = e.target;
    setValue(eventValue);
    if (typeof onChange === 'function') {
      onChange({
        target: _objectSpread2(_objectSpread2({}, props), {}, {
          value: eventValue,
          checked
        }),
        stopPropagation() {
          e.stopPropagation();
        },
        preventDefault() {
          e.preventDefault();
        }
      });
    }
  };
  useEffect(() => {
    setValue(selected);
  }, [selected]);
  return /*#__PURE__*/createElement(RadioDiv, _extends({
    row: horizontal
  }, styles === null || styles === void 0 ? void 0 : styles.root), Children.map(children, (child, index) => {
    const isChecked = value === child.props.value;
    return /*#__PURE__*/cloneElement(child, _objectSpread2(_objectSpread2({}, props), {}, {
      isChecked,
      key: index,
      onChange: handleChange
    }));
  }));
};

export default RadioGroup;
